"use client"

import { t } from "@/languages/i18n"
import { formatDateSimple } from "@/lib/utils"
import { LetakResponseDataObject } from "@/types/codegen/data-contracts"
interface LeafletMobileHeaderProps {
    leaflet: LetakResponseDataObject
}

export const LeafletMobileHeader = ({ leaflet }: LeafletMobileHeaderProps) => {
    return (
        <div className="sm:hidden block">
            <h1 className="text-[25.6px] leading-[39.68px] font-black text-[#333] pb-[17px]">{leaflet?.attributes?.title}</h1>
            {leaflet?.attributes?.dateStart && leaflet?.attributes?.dateEnd && (
                <p className="text-base leading-[24.8px] font-normal text-[#495057] italic">
                    {t("From")}: {formatDateSimple(leaflet?.attributes?.dateStart)} {t("to")} {formatDateSimple(leaflet?.attributes?.dateEnd)}
                </p>
            )}
            {leaflet?.attributes?.description && (
                <p className="mt-4 text-base leading-[24.8px] font-normal text-[#495057]">{leaflet.attributes.description}</p>
            )}
        </div>
    )
}

